import { render, staticRenderFns } from "./heroSection.vue?vue&type=template&id=2948029a&scoped=true"
import script from "./heroSection.vue?vue&type=script&lang=ts"
export * from "./heroSection.vue?vue&type=script&lang=ts"
import style0 from "./heroSection.vue?vue&type=style&index=0&id=2948029a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948029a",
  null
  
)

export default component.exports